<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('nova-marca') }}</h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" tag="button" @click="fechar()">
                        {{ $t('fechar') }}
                    </button>
                    <button
                        v-if="permissao.create"
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>

            <div class="columns mt-2">
                <div class="column is-6">
                    <v-input
                        v-model="marca.descricao"
                        :placeholder="'descricao-da-marca-placeholder'"
                        :maxlength="50"
                        :title="'descricao-marca'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!marca.descricao"
                        ref="descricaoInput"
                    />
                </div>
                <div class="column is-6">
                    <label for="situacao" v-text="$t('situacao-marca')" />
                    <v-select
                        ref="situacaoSelect"
                        :selectOnTab="true"
                        :options="situacoes"
                        :value="situacao"
                        @input="updateSituacao"
                        :getOptionLabel="getLabel"
                        placeholder="situacao-da-marca-placeholder"
                        class="no-clear"
                    >
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MarcaService from '@/services/MarcaService';
import MarcaValidation from '@/services/validations/MarcaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            isSaving: false,
            marca: {
                situacao: 1,
            },
            editable: false,
            title: '',
            msgs: [],
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isUpdate: false,
        };
    },
    created() {
        this.service = new MarcaService(this.$http, this.$router);
        this.validation = new MarcaValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'marcas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'marca' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'marca' },
                });
            }
        }
    },
    methods: {
        fechar(action = 'close', situacao = 1) {
            this.$emit('fecharModal', 'marca', action, situacao);
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.marca.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        save(redirect = this.redirectToList) {
            this.marca = this.mapTosave(this.marca);
            if (this.validation.validate(this.marca, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.marca)
                    .then((body) => {
                        if (body.content) {
                            this.marca = body.content;
                            let msg = 'msg-marca-salvo';
                            this.msgs.push(new Message('success', msg, true));
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.fechar('save', this.marca.situacao);
                    });
            }
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    margin-bottom: 40px;
    min-height: 500px;
    padding: 17px 15px;
    border-radius: 5px;
}
</style>
